import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import OptionConfigurationImage from "shared/ui/option-configuration-image";
import Heading from "shared/ui/typography/Heading";
import { concatClassnames } from "shared/utils/concatClassnames";
import StandardProductAvailability from "../availability";
import StandardProductConfig from "../config";
import { useProductType } from "app/hooks/shared/standard-product/useProductType";
import { useStandardProductAvailability } from "app/hooks/shared/standard-product/useStandardProductAvailability";
import StandardProductAvailabilityModal from "widgets/configurator/standard-product-availability-modal";
import { useState } from "react";

interface Props {
  standardProduct: CategoryStandardProduct;
  className?: string;
  index: number;
}

const StandardProductDescription = ({
  standardProduct,
  className,
  index,
}: Props) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const isNotAccesoire = useProductType(standardProduct);
  const { getStandardProductAvailability } = useStandardProductAvailability();
  const availability = getStandardProductAvailability(standardProduct);

  const inStockWarehousesQty = Object.keys(availability.pickUp).reduce(
    (qty, warehouseName) =>
      qty +
      (availability.pickUp[warehouseName as "amsterdam" | "vlaardingen"]!
        .conditionType === "productInStock"
        ? 1
        : 0),
    0,
  );

  return (
    <>
      <div
        className={concatClassnames(
          "gg-mb-6 md:gg-mb-10 lg:gg-mb-0",
          "gg-grid gg-grid-cols-7 lg:gg-flex lg:gg-items-start lg:gg-gap-0",
          className,
        )}
      >
        <div
          className={concatClassnames(
            "gg-h-20 gg-w-20 gg-shrink-0 sm:gg-h-32 sm:gg-w-32 lg:gg-h-40 lg:gg-w-40",
            "gg-mt-2 lg:gg-mr-7 lg:gg-mt-0 lg:gg-pt-2",
            "gg-col-span-2",
          )}
        >
          <OptionConfigurationImage
            imageId={standardProduct.thumbnailId || standardProduct.imageId}
            className="gg-h-full gg-w-full"
          />
        </div>

        <div className={concatClassnames("gg-col-span-5 gg-w-full")}>
          <Heading headingLevel="h2">{standardProduct.name}</Heading>

          <StandardProductConfig standardProduct={standardProduct} />

          {/* Commented until gets accepted by marketing again */}
          {/* {isNotAccesoire && (
            <p className={"gg-flex gg-items-center gg-text-sm"}>
              <span
                className={concatClassnames(
                  "gg-mr-1 gg-block gg-h-2 gg-w-2 gg-rounded-full",
                  inStockWarehousesQty > 0 ? "gg-bg-emerald" : "gg-bg-orange",
                )}
              ></span>{" "}
              Op voorraad in{" "}
              <button
                className="gg-ml-1 gg-underline"
                onClick={() => setModalOpen(true)}
              >
                {inStockWarehousesQty} vestingen
              </button>
            </p>
          )} */}

          {/*{isNotAccesoire && (*/}
          {/*  <>*/}
          {/*    <hr className="2xl:gg-w-10/12" />*/}
          {/*    <StandardProductAvailability*/}
          {/*      className="gg-mt-3"*/}
          {/*      standardProduct={standardProduct}*/}
          {/*    />*/}
          {/*  </>*/}
          {/*)}*/}
        </div>
      </div>

      {/* Commented until gets accepted by marketing again */}
      {/* <StandardProductAvailabilityModal
        isOpen={isModalOpen}
        setIsOpen={setModalOpen}
        product={standardProduct}
      /> */}
    </>
  );
};
export default StandardProductDescription;
